module.exports = __webpack_public_path__ + "static/media/trash.30821917.svg";